export const ACTION = 'ACTION'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const TOKEN = 'TOKEN'
export const TAB_NAME = 'TAB_NAME'
export const USER_NAME = 'USER_NAME'
export const CACHE_DATA = 'CACHE_DATA'
export const PERMISSION = 'PERMISSION'
export const TALGINDEX = 'TALGINDEX'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js